import { Well } from '@/components/Elements';
import { ContentLayout } from '@/components/Layout';
import { PageHeading } from '@/components/Layout/PageHeading';

import { BankAccount } from '../components/BankAccount';

const title = 'Bank Account';

export const Banking = () => (
  <ContentLayout title={title}>
    <Well>
      <>
        <PageHeading title={title} />
        <BankAccount />
      </>
    </Well>
  </ContentLayout>
);
